export default "__VITE_ASSET__23f322d2__"